import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-253cd8a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bigbox" }
const _hoisted_2 = { class: "selectlist" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"14px","color":"#606266"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "*"),
  /*#__PURE__*/_createTextVNode(" 商品分类 ")
], -1))
const _hoisted_4 = { style: {"position":"relative"} }
const _hoisted_5 = { class: "my_uploader" }
const _hoisted_6 = { class: "WangEditor" }
const _hoisted_7 = { class: "WangEditor" }
const _hoisted_8 = { style: {"background":"none","box-shadow":"none"} }
const _hoisted_9 = { class: "dialog-footer" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("确认")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Moduletitle = _resolveComponent("Moduletitle")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_SpeciFications = _resolveComponent("SpeciFications")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_Redprompt = _resolveComponent("Redprompt")!
  const _component_WangEditor = _resolveComponent("WangEditor")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_Moduletitle, {
        title: "商品分类",
        img: _ctx.img,
        isLine: true,
        isText: true,
        radius: "true",
        text: _ctx.route.query.code ? '' : '您当前选择的商品类别是：' + _ctx.SelectName + _ctx.SelectName2 + _ctx.SelectName3
      }, null, 8, ["img", "text"]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_select, {
            class: "select",
            onChange: _cache[0] || (_cache[0] = (val) => _ctx.changeSelect(val, 1)),
            disabled: _ctx.isdisabled1,
            modelValue: _ctx.addFormData.goodsTypeId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addFormData.goodsTypeId) = $event)),
            placeholder: "请选择一级分类",
            clearable: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSimpleArr1, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["disabled", "modelValue"]),
          _createElementVNode("div", null, [
            _createElementVNode("span", {
              class: _normalizeClass({ ImageLoad: _ctx.isImage }),
              style: {"font-size":"12px","color":"#f56c6c","position":"absolute","height":"0px","transition":"all 0.3s linear","display":"block","overflow":"hidden","left":"10px"}
            }, " 请选择商品分类 ", 2)
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_select, {
            class: "select",
            onChange: _cache[2] || (_cache[2] = (val) => _ctx.changeSelect(val, 2)),
            disabled: _ctx.isdisabled2,
            modelValue: _ctx.addFormData.goodsTypeId2,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addFormData.goodsTypeId2) = $event)),
            placeholder: "请选择二级分类",
            clearable: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSimpleArr2, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["disabled", "modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_select, {
            class: "select",
            onChange: _cache[4] || (_cache[4] = (val) => _ctx.changeSelect(val, 3)),
            disabled: _ctx.isdisabled3,
            modelValue: _ctx.addFormData.goodsTypeId3,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.addFormData.goodsTypeId3) = $event)),
            placeholder: "请选择三级分类",
            clearable: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSimpleArr3, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["disabled", "modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_Moduletitle, {
        title: "基本信息",
        isLine: true,
        img: _ctx.img2,
        radius: "true",
        text: ""
      }, null, 8, ["img"]),
      _createElementVNode("div", null, [
        _createVNode(_component_el_form, {
          ref: "ruleFormRef",
          model: _ctx.addFormData,
          rules: _ctx.rules,
          class: "demo-ruleForm",
          "label-width": "100px",
          size: _ctx.addFormData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "商品标题",
                      prop: "title"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.addFormData.title,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.addFormData.title) = $event)),
                          maxlength: "50",
                          placeholder: "请输入商品名称（50字内）"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "商品副标题",
                      prop: "viceTitle"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.addFormData.viceTitle,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.addFormData.viceTitle) = $event)),
                          maxlength: "40",
                          placeholder: "请输入商品简介（40字内）"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "首页标题",
                      prop: "indexTitle"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.addFormData.indexTitle,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.addFormData.indexTitle) = $event)),
                          maxlength: "10",
                          placeholder: "请输入商品首页显示标题（10字内）"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "首页副标题",
                      prop: "indexViceTitle"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.addFormData.indexViceTitle,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.addFormData.indexViceTitle) = $event)),
                          maxlength: "10",
                          placeholder: "请输入商品首页显示简介（10字内）"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "商品货号",
                      prop: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.addFormData.code,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.addFormData.code) = $event)),
                          placeholder: "后台自动生成，不可编辑",
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "商品品牌",
                      prop: "brandNo"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          style: {"width":"100%"},
                          filterable: "",
                          onChange: _cache[11] || (_cache[11] = (val) => _ctx.bardSelect(val)),
                          modelValue: _ctx.addFormData.brandNo,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.addFormData.brandNo) = $event)),
                          placeholder: "请选择品牌"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brandlistData, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.brandNo,
                                label: item.name,
                                value: item.brandNo
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "商品关键词",
                      prop: "keyword"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.addFormData.keyword,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.addFormData.keyword) = $event)),
                          placeholder: "请输入商品关键词（方便搜索）"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "配置信息",
                      prop: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.addFormData.cfgField,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.addFormData.cfgField) = $event)),
                          placeholder: "如无则跳过此步骤"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules", "size"])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_Moduletitle, {
        title: "规格属性",
        isLine: true,
        img: _ctx.img3,
        radius: "true",
        text: ""
      }, null, 8, ["img"]),
      _createVNode(_component_SpeciFications, {
        productSpecVo: _ctx.addFormData.productSpecVo,
        apiShopSpecProducts: _ctx.addFormData.apiShopSpecProducts,
        submitTableData: _ctx.submitTableData,
        "onUpdate:submitTableData": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.submitTableData) = $event))
      }, null, 8, ["productSpecVo", "apiShopSpecProducts", "submitTableData"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_Moduletitle, {
        title: "上传商品图册",
        isLine: true,
        img: _ctx.img4,
        radius: "true",
        text: ""
      }, null, 8, ["img"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_upload, {
          class: "upload-demo",
          action: _ctx.UploadUrl,
          "list-type": "picture-card",
          "on-preview": _ctx.handlePictureCardPreview,
          "on-remove": _ctx.handleRemove,
          "on-success": _ctx.handleSuccess,
          "before-upload": _ctx.beforeAvatarUpload,
          accept: ".jpg,.jpeg,.bmp,.png,.GIF,.JPG,.PNG",
          limit: 10,
          multiple: "",
          "file-list": _ctx.fiveImg ? _ctx.fiveImg : null
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_Plus)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["action", "on-preview", "on-remove", "on-success", "before-upload", "file-list"]),
        _createVNode(_component_Redprompt, { text: "说明:最多支持上传10张图片，每张大小不超过2M，格式为JPG或PNG" })
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_Moduletitle, {
        title: "图文介绍",
        isLine: true,
        img: _ctx.img5,
        radius: "true",
        text: "上传图片尺寸建议：750px高自定义"
      }, null, 8, ["img"]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_WangEditor, {
          contentHtml: _ctx.addFormData.imgTextIntro,
          onWangEditorURl: _ctx.WangEditorURl,
          onGetWangEditorValue: _cache[16] || (_cache[16] = 
            (val) => {
              _ctx.addFormData.imgTextIntro = val;
            }
          )
        }, null, 8, ["contentHtml", "onWangEditorURl"])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_Moduletitle, {
        title: "售后保障",
        isLine: true,
        img: _ctx.img6,
        radius: "true",
        text: "上传图片尺寸建议：750px高自定义"
      }, null, 8, ["img"]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_WangEditor, {
          contentHtml: _ctx.addFormData.afterSaleService,
          onGetWangEditorValue: _cache[17] || (_cache[17] = 
            (val) => {
              _ctx.addFormData.afterSaleService = val;
            }
          )
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.addFormData.afterSaleService), 1)
          ]),
          _: 1
        }, 8, ["contentHtml"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_el_button, {
        color: !_ctx.route.query.code ? '#0981FF' : '#67c23a',
        style: {"color":"#fff"},
        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(!_ctx.route.query.code ? "完成创建" : "修改"), 1)
        ]),
        _: 1
      }, 8, ["color"])
    ]),
    (_ctx.imgViewerVisible)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 0,
          "url-list": _ctx.MyfiveImg,
          onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.imgViewerVisible = false))
        }, null, 8, ["url-list"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.Disabledisplay,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.Disabledisplay) = $event)),
      title: "提示",
      width: "380px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_9, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.Disabledisplay = false))
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, _toDisplayString(_ctx.dialogTitle), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}